import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from 'react-router-dom';

const Navigation = (props) => {
  const { User, isAdmin, onLogout } = props;
  const style = { paddingRight: "2%" }
  return (
    <Navbar expand="lg">
      <Container fluid>
        <Navbar.Brand as={NavLink} to="/ytd_report">
          <img src="images/TTD_Lockup_BlackInk.png" height="15" alt="Logo1" style={style} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/ytd_report">YTD Dashboard</Nav.Link>
            <Nav.Link as={NavLink} to="/mom_report">MoM Report</Nav.Link>
            <Nav.Link as={NavLink} to="/dashboard">Solution Dashboard</Nav.Link>
            {isAdmin && <Nav.Link as={NavLink} to="/unresolved_entities">Unresolved Entities</Nav.Link>}
            {isAdmin && <Nav.Link as={NavLink} to="/backfill_entity">Backfill Entity</Nav.Link>}
            {isAdmin && <Nav.Link as={NavLink} to="/solution_mapping">Solution Mapping</Nav.Link>}
            {isAdmin && <Nav.Link as={NavLink} to="/Users">Users</Nav.Link>}
            {isAdmin && <Nav.Link as={NavLink} to="/visits">Visits</Nav.Link>}
          </Nav>
          <Nav.Link className="me-2">{User.email}</Nav.Link>
          <Button variant="outline-secondary" size="sm" onClick={onLogout}>Logout</Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
